export default __webpack_public_path__ + "static/media/hotel.5cccfb82.svg";